<template>
  <div>
    <a-spin :spinning="loading">
      <div class="box" :style="{ height: height }">
        <div class="left">
          <div class="title">模型组件</div>
          <div class="box-text">
            <div
              @click="selectItem(item)"
              v-for="(item, index) in models"
              :key="index"
              class="one"
            >
              <div class="one-box">
                <img class="img" :src="item.icon" />
                <div class="text">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div  class="content">
          <div class="title">内容模型字段</div>
          <div v-for="(item, index) in selectModels" :key="index" class="field">
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 1"
              class="card"
              :id="'xx' + index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div class="text-plord">
                  <el-radio
                    style="margin-bottom: 10px"
                    :key="reIndex"
                    v-for="(reItem, reIndex) in item.optionContent"
                    v-model="reIndex"
                    :label="0"
                    >{{
                      reItem.content ? reItem.content : "选项" + (reIndex + 1)
                    }}</el-radio
                  >
                  <div style="text-indent: 0" class="help-text">
                    {{ item.helpInformation }}
                  </div>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 2"
              class="card"
              :id="'xx' + index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div class="text-plord">
                  <el-checkbox
                    style="margin-bottom: 10px"
                    :key="cheIndex"
                    v-for="(cheItem, cheIndex) in item.optionContent"
                    v-model="cheIndex"
                    :label="0"
                    >{{
                      cheItem.content
                        ? cheItem.content
                        : "选项" + (cheIndex + 1)
                    }}</el-checkbox
                  >
                  <div style="text-indent: 0" class="help-text">
                    {{ item.helpInformation }}
                  </div>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">组件属性设置</div>
          <div v-if="selectModels.length > 0" class="form">
            <el-form
              :model="selectModels[selectIndex]"
              :rules="rules"
              ref="ruleForm"
              label-width="80px"
              class="demo-ruleForm"
            >
              <div v-if="selectTypeOne == 1 || selectTypeOne == 2">
                <el-form-item label="字段名称" prop="textName">
                  <el-input
                    v-model="selectModels[selectIndex].textName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签名称" prop="labelName">
                  <el-input
                    v-model="selectModels[selectIndex].labelName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="帮助信息">
                  <el-input
                    v-model="selectModels[selectIndex].helpInformation"
                    placeholder="请输入帮助信息"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 1"
                  label="选项内容"
                  prop="optionContent"
                >
                  <vuedraggable
                    @end="onUpdate"
                    class="wrapper"
                    v-model="selectModels[selectIndex].optionContent"
                  >
                    <!-- 过度效果 -->
                    <transition-group>
                      <div
                        class="radio"
                        :key="redioIndex"
                        v-for="(redio, redioIndex) in selectModels[selectIndex]
                          .optionContent"
                      >
                        <el-radio v-model="redioIndex" :label="0"></el-radio>
                        <el-input
                          v-model="
                            selectModels[selectIndex].optionContent[redioIndex]
                              .content
                          "
                          style="width: 137px"
                          placeholder="请输入内容"
                        ></el-input>
                        <img
                          @click="tianjia(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/tianjia.jpg"
                        />
                        <img
                          @click="jianqu(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/jianqu.jpg"
                        />
                        <img class="rideo-img" src="@/assets/images/sort.jpg" />
                      </div>
                    </transition-group>
                  </vuedraggable>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 2"
                  label="选项内容"
                  prop="optionContent"
                >
                  <vuedraggable
                    @end="onUpdate"
                    class="wrapper"
                    v-model="selectModels[selectIndex].optionContent"
                  >
                    <!-- 过度效果 -->
                    <transition-group>
                      <div
                        class="radio"
                        :key="redioIndex"
                        v-for="(redio, redioIndex) in selectModels[selectIndex]
                          .optionContent"
                      >
                        <el-checkbox style="margin-right: 10px"> </el-checkbox>
                        <el-input
                          v-model="
                            selectModels[selectIndex].optionContent[redioIndex]
                              .content
                          "
                          style="width: 137px"
                          placeholder="请输入内容"
                        ></el-input>
                        <img
                          @click="tianjia(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/tianjia.jpg"
                        />
                        <img
                          @click="jianqu(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/jianqu.jpg"
                        />
                        <img class="rideo-img" src="@/assets/images/sort.jpg" />
                      </div>
                    </transition-group>
                  </vuedraggable>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </a-spin>
    <el-button
      :loading="loadingSubmint"
      style="
        margin-left: 227px;
        margin-top: 20px;
        background: #176de6;
        justify-content: center;
      "
      @click="submit"
        v-if="codeData.indexOf('299') != -1"
      size="medium"
      type="primary"
      >保存</el-button
    >
  </div>
</template>

<script>
import { message } from "ant-design-vue";
// 导入组件
import vuedraggable from "vuedraggable";
import { addOrUpdateQuestionnaireContent,selectListByModelId } from "../index";

export default {
  name: "HelloWorld",
  components: { vuedraggable },
  props: {},
  data() {
    return {
      // 定义列表
      loadingSubmint: false,
      models: [
        {
          type: 1,
          name: "单选按钮",
          id: 1,
          icon: require("@/assets/images/d_btn.png"),
        },
        {
          type: 2,
          name: "多选按钮",
          id: 2,
          icon: require("@/assets/images/d_btns.png"),
        },
      ],
      radio: "1",
      checked: "",
      selectModels: [],
      selectIndex: 0,
      rules: {
        textName: [
          { required: true, message: "请输入字段名称", trigger: "blur" },
        ],
        labelName: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
        ],
        wordLimit: [
          { required: true, message: "请输入字数限制", trigger: "blur" },
        ],
        optionContent: [
          { required: true, message: "请输入选项内容", trigger: "blur" },
        ],
        inputLimits: [
          { required: true, message: "请输入限制", trigger: "blur" },
        ],
        dateType: [
          { required: true, message: "请输入时间类型", trigger: "blur" },
        ],
        defaultDate: [
          { required: true, message: "请输入默认时间", trigger: "blur" },
        ],
        uploadType: [
          { required: true, message: "请输入上传类型", trigger: "blur" },
        ],
        fileSize: [
          { required: true, message: "请输入大小限制", trigger: "blur" },
        ],
      },
      selectTypeOne: 1,
      loading: false,
      codeData: [],
      height: 0,
      isCollectId:0,
    };
  },
  updated() {},
  mounted() {
    this.height = document.documentElement.clientHeight - 360 + "px";
    window.onresize = () => {
      return (() => {
        this.height = document.documentElement.clientHeight - 360 + "px";
      })();
    };
  },
  created() {
    this.isCollectId = Number(this.$route.query.isCollectId) || sessionStorage.getItem('wenjuanCollectId');
    if(this.isCollectId){
      this.getSelectList();
    }
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    saveCollect() {},
    goAnchor(selector) {
      this.$el.querySelector(`#${selector}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    getSelectList() {
       this.loading = true;
      selectListByModelId({
        id: this.isCollectId,
      }).then((res) => {
        if (res.code == 0) {
           this.selectModels = res.data;
          if(this.selectModels.length > 0){
              this.selectModels.forEach(element => {
                  if(element.type == 0){
                        element.type = 1;
                  }else{
                     element.type = 2;
                  }
              });
          }
          if (this.selectModels.length == 0) {
            this.selectModels.push({
                type: 1,
                textName: "",
                labelName: "",
                helpInformation: "",
                optionContent: [
                  {
                    content: "",
                    sort: 1,
                  },
                  {
                    content: "",
                    sort: 2,
                  },
                ],
              });
          }
          this.selectType({},0)
          this.loading = false;
        }
      });
    },
    backPage() {
      this.$router.push("/index/configure/substance_model_management");
    },
     selectType(item, index) {
      if (index == this.selectModels.length) {
        this.selectIndex = 0;
        this.selectTypeOne = this.selectModels[this.selectIndex].type;
      } else {
        this.selectIndex = index;
        this.selectTypeOne = this.selectModels[this.selectIndex].type;
      }
      this.selectModels = JSON.parse(JSON.stringify(this.selectModels));
    },
    submit() {
      let validData = JSON.parse(JSON.stringify(this.selectModels));
      for (let index = 0; index < validData.length; index++) {
        let item = validData[index];
        if (!item.textName) {
          // 验证字段是否填写
          message.error("请正确填写数据");
          this.selectType(item, index);
          this.goAnchor("xx" + index);
          this.$nextTick(() => {
            this.$refs.ruleForm.validate((valid) => {});
          });
          return;
        }
        if (!item.labelName) {
          // 验证标签名是否填写
          message.error("请正确填写数据");
          this.selectType(item, index);
          this.goAnchor("xx" + index);
          this.$nextTick(() => {
            this.$refs.ruleForm.validate((valid) => {});
          });
          return;
        }
        // 验证多选按钮
        if (item.type == 1 || item.type == 2) {
          for (
            let indexTwo = 0;
            indexTwo < item.optionContent.length;
            indexTwo++
          ) {
            if (!item.optionContent[indexTwo].content) {
              this.selectType(item, index);
              this.goAnchor("xx" + index);
              message.error("选项内容必填");
              return;
            }
          }
        }
        item.type = item.type == 1?0:1;
        item.isQuestionnaireSurveyId = sessionStorage.getItem('wenjuanCollectId') || this.isCollectId;
      }
      this.loadingSubmint = true;
      addOrUpdateQuestionnaireContent(validData).then((res)=>{
          if(res.code == 0){
             this.$router.push({
                path: "/index/questionnaire",
            });
            this.loadingSubmint = false;
          }
      })
    },
    onUpdate() {
      // 处理排序
      if (
        this.selectModels[this.selectIndex] &&
        this.selectModels[this.selectIndex].optionContent
      ) {
        this.selectModels[this.selectIndex].optionContent.forEach(
          (element, index) => {
            element.sort = index;
          }
        );
      }
    },
    tianjia() {
      this.selectModels[this.selectIndex].optionContent.push({
        content: "",
        sort: this.selectModels[this.selectIndex].optionContent.length,
      });
    },
    jianqu(index) {
      if (this.selectModels[this.selectIndex].optionContent.length == 1) {
        message.error("需要保留一个选项");
        return;
      }
      this.selectModels[this.selectIndex].optionContent.splice(index, 1);
      this.onUpdate();
    },
    selectType(item, index) {
      if (index == this.selectModels.length) {
        this.selectIndex = 0;
        this.selectTypeOne = this.selectModels[this.selectIndex].type;
      } else {
        this.selectIndex = index;
        this.selectTypeOne = this.selectModels[this.selectIndex].type;
      }
      this.selectModels = JSON.parse(JSON.stringify(this.selectModels));
    },
    selectItem(item) {
      let itemData = {};

      if (item.type == 1 || item.type == 2) {
        itemData = {
          type: item.type,
          textName: "",
          labelName: "",
          helpInformation: "",
          optionContent: [
            {
              content: "",
              sort: 1,
            },
            {
              content: "",
              sort: 2,
            },
          ],
        };
      }
      this.selectModels.push(itemData);
    },
    deleteFn(item, index) {
      if (this.selectModels.length == 1) {
        message.error("必须保留一个选项");
        return;
      }
      this.selectModels.splice(index, 1);
      this.selectType(item, index);
    },
    handleChange() {},
  },
};
</script>
<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.box {
  display: flex;
  margin-top: 24px;
  .left {
    width: 228px;
    background: #fff;
    padding: 24px;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000;
    }
    .box-text {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
    }
    .one {
      width: 90px;
      height: 90px;
      text-align: center;
      border: solid 1px #d9d9d9;
      display: flex;
      align-items: center;
      box-shadow: 0px 0px 1.5px 0px #d9d9d9;
      cursor: pointer;
      .one-box {
        text-align: center;
        width: 100%;
        .text {
          margin-top: 6px;
        }
      }
    }
    .one:nth-child(2) {
      .text {
        margin-top: 7px;
      }
    }
    .one:nth-child(2n) {
      border-left: none;
    }
    .one:nth-child(11) {
      border-bottom: solid 1px #d9d9d9;
    }
    .one:nth-child(12) {
      border-bottom: solid 1px #d9d9d9;
    }
  }
  .content {
    flex: 1;
    background: #f2f3f5;
    padding: 24px;
    overflow-y: auto;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000;
    }
    .card {
      background: #fff;
      border-radius: 6px;
      position: relative;
      width: 100%;
      font-size: 16px;
      color: #000;
      margin-top: 24px;
      cursor: pointer;
      .card-content {
        display: flex;
        padding: 24px;
      }
      .card-none {
        display: flex;
        .xin {
          color: #de7baa;
          margin-right: 4px;
        }
      }
      .text-plord {
        margin-left: 20px;
      }
    }
    .delete {
      width: 100%;
      height: 100%;
      position: absolute;
      border: dashed 2px #1890ff;
      border-radius: 4px;
      top: 0;
      right: 0;
    }
    .icon {
      color: #1890ff;
      font-size: 24px;
      position: absolute;
      right: -10px;
      top: -16px;
      z-index: 99999;
    }
    /deep/ .el-radio__inner::after {
      width: 8px;
      height: 8px;
    }
    /deep/ .el-radio__inner {
      width: 18px;
      height: 18px;
    }
    /deep/ .el-checkbox__inner {
      width: 18px;
      height: 18px;
    }
  }
  .right {
    width: 380px;
    padding: 24px;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000;
    }
    .form {
      margin-top: 24px;
      .status {
        border: solid 1px #dcdfe6;
        border-radius: 4px;
        padding-left: 10px;
      }
      /deep/ .el-radio__inner::after {
        width: 8px;
        height: 8px;
      }
      /deep/ .el-radio__inner {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.radio {
  margin-bottom: 12px;
  /deep/ .el-radio {
    margin-right: 0px !important;
  }
  /deep/ .el-radio__label {
    display: none !important;
  }
  /deep/ .el-radio__input {
    margin-right: 10px;
  }
}
.rideo-img {
  width: 18px;
  height: 18px;
  margin-left: 10px;
  cursor: pointer;
}
/deep/ .ant-input-group .ant-input {
  height: 40px !important;
}
.help-text {
  color: #8393a3;
  font-size: 14px;
  margin-top: 12px;
  text-indent: 24px;
}
.help-select {
  margin-left: 144px;
  margin-top: -20px;
  /* margin-bottom: 24px; */
  padding-bottom: 20px;
  color: #8393a3;
  font-size: 14px;
}
.card-text {
  min-width: 85px;
}
</style>